import { Injectable, effect } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { UploadedDiariesModel } from '../models/uploadedDiaries.Model';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BrokerId, BrokerService } from '../core/broker/broker.service';

@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  private DiaryUploaded$: Subject<UploadedDiariesModel[]> = new Subject<
    UploadedDiariesModel[]
  >();
  private hubConnection?: signalR.HubConnection;
  private connectedBrokerId?: BrokerId;

  constructor(private broker: BrokerService) {
    this.connect(this.broker.brokerId());
    // Reconnect with the new brokerId if the broker changes after the
    // connection is up (only possible locally via the ?brokerId= override).
    effect(() => {
      const brokerId = this.broker.brokerId();
      if (this.connectedBrokerId && brokerId !== this.connectedBrokerId) {
        this.hubConnection?.stop();
        this.connect(brokerId);
      }
    });
  }

  private connect(brokerId: BrokerId) {
    this.connectedBrokerId = brokerId;
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(
        `${environment.apiManagement.webSocket.address}?subscription-key=${environment.apiManagement.webSocket.subscriptionKey}&brokerId=${brokerId}`,
        {
          transport: signalR.HttpTransportType.WebSockets,
          skipNegotiation: true,
        }
      )
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.startConnection();
    this.ReceiveMsg();
    this.GetDiaryUploaded();
  }

  public async startConnection() {
    this.hubConnection
      ?.start()
      .then(() => console.log('Connection started'))
      .catch((err) =>
        setTimeout(() => {
          console.log('Error while starting connection: ' + err);
          this.startConnection();
        }, 5000)
      );
  }
  public async ReceiveMsg() {
    this.hubConnection?.on('ReceiveMsg', (data) => {
      // console.log(data);
    });
  }
  public async GetDiaryUploaded() {
    this.hubConnection?.on('GetDiaryUploaded', (data: UploadedDiariesModel[]) => {
      // The hub broadcasts the merged queue of every broker; keep only the
      // active broker's rows. Items without a brokerId predate the
      // multi-broker rollout and are Chill's ('01'), matching the backend default.
      const brokerId = this.broker.brokerId();
      this.DiaryUploaded$.next(
        (data ?? []).filter((d) => (d.brokerId ?? '01') === brokerId)
      );
    });
  }

  public get AllFeedObservable(): Observable<UploadedDiariesModel[]> {
    return this.DiaryUploaded$.asObservable();
  }

  public async invokeGetDiaryUploaded() {
    this.hubConnection?.invoke('GetDiaryUploaded');
  }
}
